/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mean_Known_Seahorse_YellInputs */

const fr_mean_known_seahorse_yell = /** @type {(inputs: Mean_Known_Seahorse_YellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes séances`)
};

/**

* @param {Mean_Known_Seahorse_YellInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mean_known_seahorse_yell = /** @type {((inputs?: Mean_Known_Seahorse_YellInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mean_Known_Seahorse_YellInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mean_known_seahorse_yell(inputs)
});